<script>
  import StartTrendingModal from '@app-components/modal/StartTrendingModal.svelte';
  import StartTrendingButton from '@app-components/profile/StartTrendingButton.svelte';
  import Track from '@utils/track';
  import UserAjax from '@ajax/user';
  export let currentUser = null;
  export let mobile = false;
  let showTrendingModal = false;
  let showButton = false;
  let handleStartTrending = async function () {
    Track.startTrendingClick({ currentUser: currentUser });
    showTrendingModal = true;
  };
  let handleCloseModal = function () {
    showTrendingModal = false;
  };
  let handleCompleted = function () {
    showButton = false;
  };
  let loadData = async function () {
    let data = await UserAjax.startTrending();
    showButton = data.show_start_trending;
  };
  loadData();
</script>

<style style="text/scss" lang="scss">
</style>

{#if showButton}
  {#if showTrendingModal}
    <StartTrendingModal
      currentUser={currentUser}
      mobile={mobile}
      bind:showModal={showTrendingModal}
      on:completed={handleCompleted}
      on:close={handleCloseModal} />
  {/if}

  <StartTrendingButton on:clicked={handleStartTrending} mobile={mobile} />
{/if}
